'use client';

import dynamic from 'next/dynamic';
import { Container } from 'ui/components/4-habitats/Container';
import logger from 'helpers/logger';

const Survey = dynamic(() => import('ui/components/3-organisms/Survey/Survey').then((m) => m.Survey), {
	ssr: false,
});

export const SurveyFeature: React.FC<Content.Survey> = ({ content }) => {
	const { surveyJson, title } = content?.properties ?? {};

	if (!surveyJson) {
		return null;
	}

	let parsedSurveyJson;
	try {
		parsedSurveyJson = typeof surveyJson === 'string' ? JSON.parse(surveyJson) : surveyJson;
	} catch (error) {
		logger.error('Failed to parse survey JSON:', error);
		return null;
	}

	return (
		<Container width="std" section>
			{title && <h2>{title}</h2>}
			<Survey surveyJson={parsedSurveyJson} />
		</Container>
	);
};
